import React from "react";
import { ApolloProvider, Query } from "react-apollo";
import client from "lib/ApolloClient";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import { navigate } from "gatsby";
import ReactLoading from "react-loading";

const getResourceClassMapping = gql`
  query getResourceClassMapping($searchForm: SearchForm) {
    getResourceClassMapping(Input: $searchForm) {
      classItemList {
        parClassSN
        classMappingList {
          classSN
          classCount
        }
      }
      classPath
    }
  }
`;

class ResourceClassMapping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: props.readerStore.auth,
    };
  }

  @autobind
  setPar(sn, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.par = sn;
    delete params["sc"];
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  render() {
    let { t, searchForm } = this.props;
    let { resourceType } = searchForm;
    let classType = "class";
    if (resourceType === "journal") {
      classType = "eb_journal_cate";
    } else if (resourceType === "paper_journal") {
      classType = "eb_paperjournal_cate";
    } else if (resourceType === "ebook") {
      classType = "ebookclass_dir";
    }
    return (
      <>
        <ApolloProvider client={client.jumperrwdClient}>
          <Query
            query={getResourceClassMapping}
            fetchPolicy="network-only"
            variables={{
              searchForm: searchForm,
            }}>
            {({ loading, error, data, refetch }) => {
              if (loading)
                return (
                  <center>
                    <ReactLoading
                      type="cylon"
                      height={"10%"}
                      width={"20%"}
                      color="#005D98"
                    />
                  </center>
                );
              if (error) return `Error!${error.message}`;
              if (data.getResourceClassMapping) {
                let { classItemList, classPath } = data.getResourceClassMapping;
                return (
                  <>
                    {classPath && classPath.length > 0 && (
                      <div className="breadcrumb">
                        <ul>
                          {t("jumper.common.table.path")}
                          {classPath.map((path) => {
                            return (
                              <li>
                                <a
                                  tabIndex="0"
                                  onClick={this.setPar.bind(this, path)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      this.setPar(path, e);
                                    }
                                  }}>
                                  {t(
                                    "jumperrwd." + classType + ".name." + path
                                  )}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    )}
                    {classItemList &&
                      classItemList.map((classItem) => {
                        let { parClassSN, classMappingList } = classItem;
                        return (
                          <div className="tab-content">
                            <div className="subtitle">
                              {t(
                                "jumperrwd." + classType + ".name." + parClassSN
                              )}
                            </div>
                            <ul className="items open">
                              {classMappingList &&
                                classMappingList.map((classMapping) => {
                                  return (
                                    <li>
                                      <a
                                        tabIndex="0"
                                        onClick={this.setPar.bind(
                                          this,
                                          classMapping.classSN
                                        )}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            this.setPar(
                                              classMapping.classSN,
                                              e
                                            );
                                          }
                                        }}>
                                        {t(
                                          "jumperrwd." +
                                            classType +
                                            ".name." +
                                            classMapping.classSN
                                        )}
                                        <span>({classMapping.classCount})</span>
                                      </a>
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                        );
                      })}
                  </>
                );
              }
              return "";
            }}
          </Query>
        </ApolloProvider>
      </>
    );
  }
}

export default ResourceClassMapping;
